import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataEntity_Main_01_Interface } from 'src/app/Interface/DataEntity/01/DataEntity_Main_01_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataEntity01Service {

  constructor(private http: HttpClient) { }

  GetSingle(id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Dataentityno01/GetSingle?id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  Submit(
    model: Array<DataEntity_Main_01_Interface>,
    image: Array<String>,
    Uncertainty: Array<String>,
    Calibration_Id: number,
    filename:string): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var DataEntityList = []
    var DataEntityDetailList = []



    var Indexer: number = 0
    for (let item of model) {

      DataEntityList.push({
        id: item.id,
        Calibration_id: Calibration_Id,
        Reference_Value: item.reference_Value,
        Set_Value: item.set_Value,
        Sample_Indication_Max: item.sample_Indication_Max,
        Sample_Indication_Min: item.sample_Indication_Min,
        Reference_Value_Center_Max: item.reference_Value_Center_Max,
        Reference_Value_Center_Min: item.reference_Value_Center_Min,
        filename: filename,
        uncertainty:Uncertainty[Indexer]
      })

      for (let itemDetail of item.detail) {
        DataEntityDetailList.push({
          id: itemDetail.id,
          main_id: Indexer,
          Reference_Value_Position_Max: Number(itemDetail.reference_Value_Position_Max),
          Reference_Value_Position_Min: Number(itemDetail.reference_Value_Position_Min),
        })
      }

      Indexer++
    }

    var DataEntityList_Image = []
    for (let item of image) {
      DataEntityList_Image.push({
        src: item,
      })
    }

    var body = {
      Calibration_id: Calibration_Id,
      model: DataEntityList,
      image: DataEntityList_Image,
      detail: DataEntityDetailList,
      Token: ''
    }

    console.log(body);


    return this.http.post(environment.BaseUrl + "Daro/Dataentityno01/Submit", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }


  uploadFile(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Dataentityno01/upload", body).pipe(
      map(data=>{
        return data
      })
    )
  }

}
